import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Panel from '../../components/common/Panel';
import DropDownFilter from '../../components/filters/DropDownFilter';
import { retailersFilter } from '../../constants/filters';
import SortOrderFilter from '../../components/filters/SortOrderFilter';
import Wall from '../../components/common/Wall';
import PageLayout from '../../components/common/PageLayout';
import AcceptedInvitationRetailersContainer from '../blocks/AcceptedInvitationRetailersContainer';
import ApprovedRetailersComponent from '../blocks/ApprovedRetailersComponent';
import Button from '../../components/common/Button';
import SearchRetailers from '../../components/blocks/SearchRetailers';
import InviteRetailerModal from '../../components/blocks/InviteRetailerModal';
import AddChannelModal from '../../components/modals/AddChannelModal';
import { reportBusinessActionToMixpanel } from '../../utils/reportBusinessActionToMixpanel';
import { useMixpanel } from 'react-mixpanel-browser';
import { RetailerApprovalStatus } from '../../constants/retailerStatus';
import { setRetailersOrder, setRetailersOrderField, sendRetailersInvitation } from '../../store/actions/pageFilters';
import { searchAllRetailers } from '../../store/actions/searchAllRetailers';

import { getChannels } from '../../store/actions/channels';
import IntegrationTiktokReturnTypeModal from '../../components/modals/IntegrationTiktokReturnTypeModal/IntegrationTiktokReturnTypeModal';

function RetailersPageContainer(props) {
  const { getChannels } = props;
  const [modal, setModal] = useState({ invite: false, channel: false });
  const [selectedChannel, setSelectedChannel] = useState({});
  const [showTiktokReturnTypeModal, setShowTiktokReturnTypeModal] = useState(false);

  const mixpanel = useMixpanel();

  const reportBi = (eventName) => {
    reportBusinessActionToMixpanel(mixpanel, eventName);
  };

  useEffect(() => {
    getChannels();
  }, [getChannels]);

  const openModal = (type) => {
    setModal({ ...modal, [type]: true });
  };

  const closeModal = (type) => {
    setModal({ ...modal, [type]: false });
  };

  const sendEmail = (emails) => {
    props.sendEmail?.(emails);
    closeModal('invite');
  };

  return (
    <>
      <Panel width={480} identifier="retailers">
        <Wall />

        <SearchRetailers search={props.searchAllRetailers} />

        <Wall />
        <DropDownFilter
          currentIndex={1}
          values={retailersFilter}
          onChange={(field) => props.setOrderField(field)}
          staticPoint
        />

        <Wall />
        <SortOrderFilter sortOrder={props.sortOrder} onChange={(order) => props.setOrder(order)} />

        <Wall />
        <Button
          margin
          text="Invite Boutique"
          onClick={() => {
            openModal('invite');
            reportBi('invite-retailers-button-click');
          }}
        />

        <Wall />
        <Button
          margin
          text="Add Sales Channel"
          onClick={() => {
            openModal('channel');
            reportBi('add-channel-button-click');
          }}
        />
      </Panel>

      <PageLayout>
        <AcceptedInvitationRetailersContainer action={RetailerApprovalStatus.PENDING} />

        <ApprovedRetailersComponent action={RetailerApprovalStatus.APPROVED} />

        <InviteRetailerModal open={modal.invite} onClose={() => closeModal('invite')} sendEmail={sendEmail} />

        <AddChannelModal
          open={modal.channel}
          onClose={() => closeModal('channel')}
          channels={props.channels}
          onChannelSelect={setSelectedChannel}
          showTiktokReturnTypeModal={setShowTiktokReturnTypeModal}
        />

        <IntegrationTiktokReturnTypeModal
          open={showTiktokReturnTypeModal}
          onClose={() => setShowTiktokReturnTypeModal(false)}
          selectedChannel={selectedChannel}
        />
      </PageLayout>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    channels: state.channels.channels,
    sortOrder: state.pageFilters.retailers.order,
  };
};

const mapDispatchToProps = (dispatch) => ({
  setOrder: (order) => dispatch(setRetailersOrder(order)),
  setOrderField: (field) => dispatch(setRetailersOrderField(field)),
  searchAllRetailers: (search) => dispatch(searchAllRetailers(search)),
  sendEmail: (emails) => dispatch(sendRetailersInvitation(emails)),
  getChannels: () => dispatch(getChannels()),
});

export default connect(mapStateToProps, mapDispatchToProps)(RetailersPageContainer);

RetailersPageContainer.propTypes = {
  setOrder: PropTypes.func.isRequired,
  setOrderField: PropTypes.func.isRequired,
  searchAllRetailers: PropTypes.func.isRequired,
  sendEmail: PropTypes.func.isRequired,
  sortOrder: PropTypes.string,
  getChannels: PropTypes.func.isRequired,
  channels: PropTypes.array.isRequired,
};
